export enum EPaymentItemCategory {
  REGULAR = "regular",
  REIMBURSEMENT = "reimbursement",
  KIT = "kit",
}
